import StatCard from './StatCard';

export default StatCard;
